// extracted by mini-css-extract-plugin
export default {"loginButton":"LoginButton_loginButton__xgy8b"};